<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14KRn0x/tc-custom/9781460387658.jpg?1703768791296" alt="This image is the cover for the book Soldier's Rebel Lover, Comrades in Arms"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Soldier's Rebel Lover, Comrades in Arms
      </h1>
      <p class="bookDescription body article font2">
        <b>A heroa rebela desire worth fighting for!  </b><br/><br/>When Major Finlay Urquhart was last on the battlefield, he shared a sizzling moment with daring Isabella Romero. Two years later, Finlay has one final duty to perform for his countryone that reunites him with this rebellious señorita!  <br/><br/>Except Isabella has her own mission, which means that no matter how much she craves Finlay's touch, she can never tell him the truth. But she's underestimated Finlay's determination to protect her, and soon she finds herself letting her guard down, one scorching kiss at a time!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marguerite Kaye
      </h2>
      
      <p class="authorDescription body article">Marguerite Kaye has written over fifty historical romances featuring feisty heroines and a strong sense of place and time. She is also co-author with Sarah Ferguson, Duchess of York, of the Sunday Times bestseller, <I>Her Heart for a Compass</I>. They are currently working on their second book together. Marguerite lives in Argyll on the west coast of Scotland. When not writing, she loves to read, cook, garden, drink martinis, and sew, though rarely at the same time.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?19eca165